import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AssociatedSkillsCredit {
  id: number;
  title: string;
  description: string;
  type: string;
  position: number;
  archivedAt: string | null;
}

export interface AssociatedSkillsArea {
  id: number;
  title: string;
  description: string;
  position: number;
  credits: AssociatedSkillsCredit[];
}

export interface AssociatedSkillsData {
  id: number;
  schoolId: number;
  visibleLevels?: number;
  areas: AssociatedSkillsArea[];
  schoolModel?: AssociatedSkillsData;
}

export interface AssociatedSkillsState {
  data: AssociatedSkillsData | null;
}

const initialState: AssociatedSkillsState = {
  data: null,
};

const associatedSkillsSlice = createSlice({
  name: "associatedSkills",
  initialState,
  reducers: {
    setAssociatedSkillsRedux(state, action: PayloadAction<AssociatedSkillsData>) {
      state.data = action.payload;
    },
    clearAssociatedSkills(state) {
      state.data = null;
    },
  },
});

    export const { setAssociatedSkillsRedux, clearAssociatedSkills } = associatedSkillsSlice.actions;
export default associatedSkillsSlice.reducer;
